import React, { useEffect } from "react";
import MetaTagContents from "../../MetaTagContents";
import { Helmet } from "react-helmet";
import NavBar from "../landingPage/header/navbar";
import Footer from "../landingPage/footer";
import Content from "./Content";
import { Layout } from "antd";
import { trackCta } from "../../analytics";

const PricingPage = () => {
  const { name, content } = MetaTagContents.SUBSCRIPTION_PLANS;

  useEffect(() => {
    trackCta('pricing_page_visit', {});
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{MetaTagContents.SUBSCRIPTION_PLANS.title}</title>
        <link rel="canonical" href="https://all3d.ai/pricing" />
        <meta name={name} content={content} />
      </Helmet>
      <NavBar />
      <Layout>
        <Content />
      </Layout>
      <Footer />
    </>
  );
};

export default PricingPage;
